import { addClientStylesheetModifications } from '@/lib/mapbox/stylesheet-mods'
import { httpGetJson } from '@/lib/net'
import {
  INIT_STYLESHEET_START,
  INIT_STYLESHEET_STOP,
} from '@/lib/performance-marks'

/**
 * Fetches stylesheet from server, adds client modifications, then hands it off
 * to the layer management service.
 */
export const initStylesheet = async () => {
  performance.mark(INIT_STYLESHEET_START)
  const stylesheet = await getStylesheet()
  addClientStylesheetModifications(stylesheet)
  performance.mark(INIT_STYLESHEET_STOP)

  return stylesheet
}

/**
 * Returns stylesheet from the server.
 */
const getStylesheet = async () => {
  const version = getStylesheetVersion()
  const styleUrl = `${window.environment.cartoUrl}/${version}/stylesheet`

  return await httpGetJson(styleUrl)
}

/**
 * Determines which stylesheet version to return.
 */
const getStylesheetVersion = () => {
  return 'v1'
}
